// Zoeken zonder accenten: "Ünal" vindt je met "unal", "Şahin" met "sahin", "Yıldız" met "yildiz".
const LOS = { ı: 'i', İ: 'i', ß: 'ss', ø: 'o', Ø: 'o', ł: 'l', Ł: 'l', đ: 'd', Đ: 'd', æ: 'ae', Æ: 'ae', œ: 'oe', Œ: 'oe', þ: 'th' };

export function fold(s) {
  return String(s ?? '')
    .replace(/[ıİßøØłŁđĐæÆœŒþ]/g, (c) => LOS[c])
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

export const matches = (text, query) => fold(text).includes(fold(query).trim());
